import { render, staticRenderFns } from "./Studentpassword.vue?vue&type=template&id=6283cd24&scoped=true&"
import script from "./Studentpassword.vue?vue&type=script&lang=js&"
export * from "./Studentpassword.vue?vue&type=script&lang=js&"
import style0 from "./Studentpassword.vue?vue&type=style&index=0&id=6283cd24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6283cd24",
  null
  
)

export default component.exports